const displayTimeZone = "America/New_York"
const displayLocale = "en-US"

export const toDisplayTime = (d: Date) =>
  d.toLocaleString(displayLocale, {
    timeZone: displayTimeZone,
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZoneName: "short",
  })

export const toDisplayDate = (d: Date) =>
  d.toLocaleString(displayLocale, {
    timeZone: displayTimeZone,
    year: "numeric",
    month: "long",
    day: "numeric",
  })

export const toDisplayYear = (d: Date) =>
  d.toLocaleString(displayLocale, {
    timeZone: displayTimeZone,
    year: "numeric",
  })

export const toDisplayMonthAndDay = (d: Date) =>
  d.toLocaleString(displayLocale, {
    timeZone: displayTimeZone,
    month: "long",
    day: "numeric",
  })

export const startOfDayDisplayed = (d: Date) => {
  let outcome = new Date(Date.parse(
    d.toLocaleString(displayLocale, {
      timeZone: displayTimeZone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZoneName: "short"
    }))
  )
  return outcome;
}

export const toCustomISODate = (date: Date) => {
  const parts = new Intl.DateTimeFormat(displayLocale, {
    timeZone: displayTimeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce((acc, part) => {
      if (part.type !== "literal") acc[part.type] = part.value;
      return acc;
    }, {} as Record<string, string>);

  const easternIso = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
  const local = new Date(easternIso);
  const eastern = new Date(
    local.toLocaleString(displayLocale, { timeZone: displayTimeZone })
    );
  const offsetMs = local.getTime() - eastern.getTime();
  const utc = new Date(local.getTime() + offsetMs);
  const utc_string = utc.toISOString()
  return  utc_string.slice(0, -5); // e.g. "2025-10-30T08:16:49.000Z"
  }

export const toISODate = (date: Date) => date.toISOString().substr(0, 19)

export const addDays = (date: Date, days: number) => {
  return new Date(date.getTime() + days * 24 * 60 * 60 * 1000)
}
